// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fallback of a part of a window (i.e. a tab) */
.errorboundary-box {
    margin: 0.5em;
    padding: 0.75em 1em;
    background-color: #fdf0ef;
    border: 1px solid #e3b1ad;
    border-left: 4px solid #c0392b;
    border-radius: 2px;
}
.errorboundary-title {
    font-weight: bold;
    margin-bottom: 0.25em;
}
.errorboundary-message {
    color: #6b7070;
    font-size: 0.85em;
    margin-bottom: 0.6em;
    word-break: break-word;
}

/* Last resort: the whole application failed */
.errorboundary-fatal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1em;
    padding: 1em;
    box-sizing: border-box;
    text-align: center;
    background-color: #595959;
    color: #fff;
    font-family: sans-serif;
}
.errorboundary-fatal button {
    padding: 0.7em 2em;
    background-color: transparent;
    color: #fff;
    border: 1px solid #fff;
    font-size: 1rem;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./js/style/ErrorBoundary.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA,8CAA8C;AAC9C;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,eAAe;AACnB","sourcesContent":["/* Fallback of a part of a window (i.e. a tab) */\n.errorboundary-box {\n    margin: 0.5em;\n    padding: 0.75em 1em;\n    background-color: #fdf0ef;\n    border: 1px solid #e3b1ad;\n    border-left: 4px solid #c0392b;\n    border-radius: 2px;\n}\n.errorboundary-title {\n    font-weight: bold;\n    margin-bottom: 0.25em;\n}\n.errorboundary-message {\n    color: #6b7070;\n    font-size: 0.85em;\n    margin-bottom: 0.6em;\n    word-break: break-word;\n}\n\n/* Last resort: the whole application failed */\n.errorboundary-fatal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1em;\n    padding: 1em;\n    box-sizing: border-box;\n    text-align: center;\n    background-color: #595959;\n    color: #fff;\n    font-family: sans-serif;\n}\n.errorboundary-fatal button {\n    padding: 0.7em 2em;\n    background-color: transparent;\n    color: #fff;\n    border: 1px solid #fff;\n    font-size: 1rem;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
